<template>
  <div v-bind:class="{ 'black_bg': this.black, 'white_bg': !this.black }">
    <div class="notificatie">
        <span>
          <span class="ad">{{ advertiser }}</span> 
          <a v-bind:href="url" target="_blank">{{line}}</a>
        </span>
        <span class="close" v-on:click="hideAd">
          <img class="close__icon" src="../assets/close.svg" />
        </span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

/* eslint-disable */
export default {
  name: 'Notification',
  props: ['black'],
  data: function() {
    return {
      advertiser: "",
      line: "",
      url: ""
    }
  },
  mounted: function() {
    axios.get('https://achtachtacht-9b8b0.firebaseio.com/.json').then(response => {
      let data = response.data;
      this.advertiser = response.data.name;
      this.line = response.data.line;
      this.url = response.data.url;
    });
  },
  methods: {
    hideAd (event) {
      this.$emit('hideAd', false)
    }
  }
}
</script>

<style scoped>
div {
  position: fixed;
  bottom: 30px;
  left: 0;
  width: 80%;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #707070;
  color: #707070;
  font-family: 'fl-mono';
  text-transform: none !important;
  z-index: 4;
  margin-left: 20%;
}

.ad {
    background: #FF6767;
    /* line-height: 14px; */
    border-radius: 5px;
    padding: 3px 6px 3px 6px;
    color: white;
}

  span {
    padding: 3px 10px 0 10px;
    font-size: 14px;
    cursor: pointer;
  }


  a {
    text-decoration: none;
    color: #707070;
  }

  a:visited {
    color: #707070;
  }

  a:hover {
    color: #383838 !important;
  }

  .close {
    float: right;
  }

  .close__icon {
    width: 20px;
  }
</style>





// WEBPACK FOOTER //
// src/components/Notification.vue